import type { LabelInValue } from 'models';
import { Modal, type ModalOptions, message } from 'ui';
import { useInviteUsersMutation } from '../../../queries';
import { EmailInviteForm, type EmailInviteFormValues } from './email-invite-form';

type EmailInviteModalOptions = {
  community: LabelInValue;
};

type P = {
  onCancel: () => void;
  options: ModalOptions<EmailInviteModalOptions>;
};

const EmailInviteModal = ({ onCancel, options }: P) => {
  const { isPending: isInvitingUsers, mutate: inviteUsers } = useInviteUsersMutation();

  const onSubmit = (data: EmailInviteFormValues) => {
    inviteUsers(
      {
        id: data.communityId,
        invitees: {
          emails: data.emails,
          phones: [],
          userIds: [],
        },
      },
      {
        onSuccess() {
          message.success('Invitations sent successfully');
          onCancel();
        },
      },
    );
  };

  return (
    <Modal isOpened={options.isOpened} onCancel={onCancel} title="Invite via e-mail">
      {options.isOpened ? (
        <Modal.HugContent>
          <EmailInviteForm
            community={options.community}
            isSubmitting={isInvitingUsers}
            onCancel={onCancel}
            onSubmit={onSubmit}
          />
        </Modal.HugContent>
      ) : null}
    </Modal>
  );
};

export default EmailInviteModal;
